/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component, Injector, Input, OnChanges } from '@angular/core';
import { AsideService } from 'app/layout/components/aside-container/aside.service';
import { ComponentItem } from 'app/shared/base/aside/component-item';
import { FormMode } from 'app/shared/enumeration/form-mode';
import { Subject, takeUntil } from 'rxjs';
import { CustomerViewViewModel } from '../models/customer-view-view.model';
import { CustomerViewService } from '../services/customer-view.service';
import { CustomerFormComponent } from '../customer-form/customer-form.component';
import { CustomerViewModel } from '../models/customer-view.model';


@Component({
	selector: 'customer-view',
	templateUrl: './customer-view.component.html',
	styleUrls: ['./customer-view.component.scss'],
	standalone: false,
})
export class CustomerViewComponent implements OnChanges {

	viewModel: CustomerViewViewModel;
	private ngUnsubscribe: Subject<boolean> = new Subject();
	@Input() basketCustomerId : number = null;
	constructor(private service: CustomerViewService, protected asideService: AsideService, private injector: Injector) {
	}
	ngAfterViewInit() {
		this.asideService.asideClose.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
			if (data === 'update') {
				this.reload();
			}
		});
	}
	ngOnDestroy() {
		this.ngUnsubscribe.next(true);
		this.ngUnsubscribe.complete();
	}
	ngOnChanges() {
		if (this.basketCustomerId) {
			this.loadViewModel();
		}
	}

	loadViewModel() {
		if (!this.basketCustomerId) return;

		this.service.getAccountCustomerView(this.basketCustomerId).then((response: CustomerViewModel) => {
			this.viewModel = new CustomerViewViewModel(response);
			this.viewModel.itemId = response.id;
		});
	}

	public reload() {
		this.loadViewModel();
	}

	doIconButtonAction(action) {
		switch (action.action) {
			case 'edit': {
				this.asideService.setAndOpen(new ComponentItem(CustomerFormComponent, { itemId: this.basketCustomerId, formMode: FormMode.Update }), this.injector);

				break;
			}
			default: {
				console.log('Unsupported action: ' + action);
				break;
			}
		}
	}
}
